<script>
  import Matrix from "../../shared/Matrix.svelte";
  import BarChart from "../../shared/BarChart.svelte";
  import Graph from "../../shared/Graph.svelte";
  import data from "../../stores/Bar1.js";
  import data2 from "../../stores/Graph_L2.js";

  const matrix1 = [
    [0, 0, 1, 0],
    [1, 0, 0, 0],
    [0, 1, 0, 0],
    [0, 0, 0, 1],
  ];
</script>

<div class="title">
  <h2>[TEMP] Demo card</h2>
</div>
<hr />
<div class="text">
  <p>
    Sample text: Lorem, ipsum dolor sit amet consectetur adipisicing elit.
    Nostrum voluptatibus, inventore totam fuga quibusdam reprehenderit?
    Repudiandae consequuntur voluptate delectus laboriosam expedita fugiat
    temporibus itaque inventore sint adipisci, id eos soluta assumenda quis a
    impedit, aperiam maxime, doloribus repellendus fugit. Voluptates earum
    voluptate maxime quas corrupti facilis harum consequuntur repudiandae
    deleniti!
  </p>
  <p>Here is a sample formula:</p>
  <p>{`$$C\\left(x\\right)=\\sum_{i=1}^Na_ix_i+\\sum_{i<j}b_{ij}x_ix_j$$`}</p>
  <p>Here is an animated bar chart:</p>
  <BarChart
    points={data.points}
    yTicks={data.yTicks}
    yLabel="per 1,000 population"
    width="400"
    height="300"
    barColor="#f1b6e8"
  />
  <p>Here is an interactive matrix:</p>
  <Matrix size="300" data={matrix1} showLabels={true} />
  <p>Here is a graph:</p>
  <Graph graph={data2} width="500" height="350" style="display: block; margin: 0 auto;"/>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
